import { connect } from 'react-redux';
import isEmpty from 'lodash.isempty';
import Page from '../../../features/page/Page';
import config from '../../../configs/reading';
import { LICENSE } from '../../../constants/reading/CommonConstants';

const { BURST } = LICENSE;

const mapStateToProps = state => {
    const { selectors } = config.root;
    let isDataReady = !selectors.hasError(state) && selectors.isDataReady(state);
    if (selectors.hasAppLicenseByName(state, BURST)) {
        isDataReady = isDataReady && !selectors.isInterventionsDataFetching(state);
    }

    return {
        isDataReady,
        hasNoSchools: isEmpty(selectors.getSchoolId(state)),
        hasNoClasses: isEmpty(selectors.getClassOrGroupId(state)),
        hasNoStudents: isEmpty(selectors.getStudentIds(state)),
        hasNoExpress: isEmpty(selectors.getResultsTableMeasures(state)),
    };
};

export default connect(mapStateToProps)(Page);
